import { ProductService } from './../../catalog/service/product.service';
import { HistoryService } from './../../../services/history.service';
import { DatePipe, CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ShopService } from '../service/shop.service';
import { Util } from '../../../utils/util';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-history-dialog',
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    TagModule,
    ButtonModule,
    TranslateModule,
  ],
  templateUrl: './history-dialog.component.html',
  styleUrl: './history-dialog.component.scss',
  providers: [DatePipe, TranslateService],
})
export class HistoryDialogComponent implements OnInit {
  actions = [];
  type: any;
  actionHeader: any[] = [
    {
      id: 'date',
      value: 'Date',
      type: 'date',
    },
    {
      id: 'modifiedBy',
      value: 'table.user',
    },
    {
      id: 'modificationType',
      value: "table.modificationType",
    },
    {
      id: 'entityId',
      value: 'table.modifiedObject',
    },
    {
      id: 'modifiedAttribute',
      value: 'table.modifiedProperty',
    },
    {
      id: 'oldValue',
      value: 'table.initialValue',
    },
    {
      id: 'newValue',
      value: 'table.finalValue',
    },
  ];
  shop;
  user;
  constructor(
    private readonly translate: TranslateService,
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private readonly historyService: HistoryService,
    private readonly productService: ProductService,
    private readonly shopService: ShopService,
  ) {
    this.shop = this.config?.data.shop;
    this.user = this.config?.data.user;
    this.type = this.config?.data.type;
  }

  ngOnInit(): void {
    let data: any = {
      entityModifiedId: this.config?.data.entityKey,
      type: this.type,
    };
    if (this.type === 'product') {
      data = { productId: this.config?.data.productId };
      this.actionHeader = this.actionHeader.filter(
        (header) => header.id != 'entityId',
      );
    }
    this.historyService.getHistory(this.type, data).subscribe({
      next: (data: any[]) => {
        this.actions = data;
      },
    });
  }

  export() {
    if (this.type === 'product') {
      this.handleExport(
        this.productService.exportHistory({ productId: this.config?.data.productId }),
        'product_history.xlsx'
      );
    } else if (this.isShopUserType(this.type)) {
      const data = {
        entityModifiedId: this.config?.data.entityKey,
        types: this.type,
      };
      this.handleExport(
        this.shopService.exportShopHistory(data),
        null // Le nom du fichier sera déterminé dynamiquement
      );
    }
  }
  
  /**
   * check if type =  ['shop', 'user']
   */
  private isShopUserType(type: any): boolean {
    return Array.isArray(type) && type.length === 2 && type.includes('shop') && type.includes('user');
  }
  
  /**
   * Gère l'export des fichiers en fonction de la réponse de l'API
   */
  private handleExport(request$: Observable<any>, defaultFilename: string | null) {
    request$.subscribe({
      next: (response) => {
        const filename = defaultFilename || Util.getFilenameFromHeaders(response.headers);
        const blob = new Blob([response.body!], { type: 'application/octet-stream' });
        const url = globalThis.URL.createObjectURL(blob);
  
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
  
        globalThis.URL.revokeObjectURL(url);
      },
      error: (err) => {
        console.error('Download failed', err);
      },
    });
  }
}
